import React from "react";
import { useShow } from "@refinedev/core";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ShowPage } from "@/components/crud";
import { DescriptionList, DescriptionItem } from "@/components/ui/description-list";
import { ICompany } from "../../types";

export const CompanyShow: React.FC = () => {
  const queryResult = useShow<ICompany>();
  const { data, isLoading } = queryResult.query;
  const record = data?.data;

  return (
    <ShowPage isLoading={isLoading}>
      <Card>
        <CardHeader>
          <CardTitle>Company Information</CardTitle>
        </CardHeader>
        <CardContent>
          <DescriptionList columns={2} bordered>
            <DescriptionItem label="Company Name">{record?.name}</DescriptionItem>
            <DescriptionItem label="Registration Number">{record?.registration_number}</DescriptionItem>
            <DescriptionItem label="Tax Number">{record?.tax_number || "N/A"}</DescriptionItem>
            <DescriptionItem label="Phone">{record?.phone || "N/A"}</DescriptionItem>
            <DescriptionItem label="Email">{record?.email || "N/A"}</DescriptionItem>
            <DescriptionItem label="Website">{record?.website || "N/A"}</DescriptionItem>
            <DescriptionItem label="Address">{record?.address || "N/A"}</DescriptionItem>
            <DescriptionItem label="Description">{record?.description || "N/A"}</DescriptionItem>
            <DescriptionItem label="Created At">
              {record?.created_at ? new Date(record.created_at).toLocaleDateString() : "N/A"}
            </DescriptionItem>
            <DescriptionItem label="Updated At">
              {record?.updated_at ? new Date(record.updated_at).toLocaleDateString() : "N/A"}
            </DescriptionItem>
          </DescriptionList>
        </CardContent>
      </Card>
    </ShowPage>
  );
};
